function initializeGtmGlobalTracking() {
  // Get all elements with the data attribute data-tracking
  const elements = document.querySelectorAll("a[data-gtm]");

  if (!elements.length) return;

  // Make sure data layer is available
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  // Register click on each element
  elements.forEach((element) => {
    // Skip if value of data attribute is empty
    if (!element.dataset.gtm) {
      return;
    }
    element.addEventListener("click", (event) => {
      // Get the value of the data attribute
      const value = element.dataset.gtm;
      // Push event to data layer
      pushToDataLayer("globalTrackingClick",{
        globalTrackingValue: value,
      });
    });
  });
}

const affiliateTrackingParams = ["affiliate", "kampagne"];

function getAffiliateTracking() {
  const affiliateTracking = {};
  // Get the affiliate tracking parameters from the URL
  const urlParams = new URLSearchParams(window.location.search);
  for (let key of affiliateTrackingParams) {
    // If the url params contain the key, add it to the affiliate tracking object,
    // else set 'organic' as the value
    affiliateTracking[key] = urlParams.get(key) || "organic";
  }
  return affiliateTracking;
}

function pushToDataLayer(event, payload, debug = false) {
  // Make sure data layer is available
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  // Loop through the payload and set '-' as value if the value is empty
  for (let key in payload) {
    if (!payload[key]) {
      payload[key] = "-";
    }
  }
  // Add the page URL withouth the query parameters to the payload
  payload.pageUrl = window.location.origin + window.location.pathname;
  // Add affiliate tracking parameters to the payload if present
  const affiliateTracking = getAffiliateTracking();
  for (let key in affiliateTracking) {
    payload[key] = affiliateTracking[key];
  }
  logDataLayer(event, payload, debug);
  // Push to data layer
  window.dataLayer.push({
    event: event,
    ...payload,
  });
}

function logDataLayer(eventName, payload, debug = false) {
  if (!debug) return;
  if (process.env.NODE_ENV != "development") return;
  const color = "#ebb434";
  let message = "DataLayer Event: " + eventName;
  message += "\n";
  message += JSON.stringify(payload, null, 2);
  console.log("%c" + message, "color:" + color);
}

export { initializeGtmGlobalTracking, pushToDataLayer };
